import styled from 'styled-components';
import {
  Alert,
  Typography,
} from '@mui/material';

import colors from '../../../../../styles/colors';

const PercentageFieldContainer = styled.div`
  max-width: 160px;
`;

const TemplateRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
`;

const TemplateFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 640px;
`;

const StyledHelperText = styled(Typography)`
  font-size: 12px;
  line-height: 16px;
  color: ${(props) => (props.$isError ? colors.base.danger : colors.shades.gamma14)};
  margin-top: 4px;
`;

const StyledAlert = styled(Alert)`
  margin-top: 8px;
  margin-bottom: 16px;
  max-width: 640px;
  font-size: 13px;
`;

export {
  PercentageFieldContainer,
  StyledHelperText,
  StyledAlert,
  TemplateFieldContainer,
  TemplateRow,
};
